import { call, put, takeLatest } from "redux-saga/effects";
import { ManagerVatReviewAction } from "../../actions";
import * as types from "../../actions/actionTypes";
import * as vatReviewApi from "../../api/vatReview/managerVatReview";
import GetFilter from "../../hocs/vatReviewReport/components/filter/tools/getFilter";
import { SetMessage } from "../../assets/errorMessages";

export function* managerWatcherVatReview() {
  yield takeLatest(types.MANAGER_VAT_REVIEW_REQUEST, worker);
}

async function fetchList(pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  return vatReviewApi.getList(page_number, GetFilter());
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(ManagerVatReviewAction.getSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerVatReviewAction.getFailure(message));
  }
}
